import * as Services from '../../services/index.js';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';

/**
 * Ensures the data is defined prior to running the validation
 * newData handles a variety of data depending on the change request type
 * @param {*} fieldName 
 * @param {*} value 
 * @param {*} locale 
 * @returns 
 */
function _validateIfDefined(fieldName, value, locale = null) {
  if (value !== undefined && value !== null) {
    return Services.validateInput(fieldName, value, locale);
  }
  return null;
}

/**
 * Sums the shares of the other beneficiaries within the given array
 * @param {*} array 
 * @returns 
 */
function _sumShares(array) {
  return array.reduce((totalShares, beneficiary) => totalShares + Number(beneficiary.shares), 0);
}

/**
 * @param data
 * @returns an array of errors or false if no errors were detected
 */
function validateForm(data) {
  const errors = {};

  // Details Validation
  errors.effectiveDate = Services.validateInput('effectiveDate', data.effectiveDate, i18n.locale);
  errors.reasonForChange = Services.validateInput('checkEmpty', data.reasonForChange);

  // New Data validation, depending on the change request type any of these may need validation
  errors.firstname = _validateIfDefined('firstname', data.newData.firstname);
  errors.lastname = _validateIfDefined('lastname', data.newData.lastname);
  errors.email = _validateIfDefined('email', data.newData.email);
  errors.birthdate = _validateIfDefined('birthdate', data.newData.birthdate, i18n.locale);
  errors.hireDate = _validateIfDefined('hireDate', data.newData.hireDate, i18n.locale);
  errors.gender = _validateIfDefined('gender', data.newData.gender);
  errors.relationship = _validateIfDefined('relationship', data.newData.relationship);
  errors.maritlStat = _validateIfDefined('maritlStat', data.newData.maritlStat);
  errors.phone = _validateIfDefined('phone', data.newData.phone);
  errors.cohabDate = _validateIfDefined('cohabDate', data.newData.cohabDate);
  errors.dateOfMarriage = _validateIfDefined('dateOfMarriage', data.newData.dateOfMarriage);
  errors.dependentCertNumber = _validateIfDefined('checkEmpty', data.newData.dependentCertNumber); // Spouse/CommonLaw cert number from another carrier
  errors.insuranceCarrier = _validateIfDefined('checkEmpty', data.newData.insuranceCarrier); // Spouse/CommonLaw Carrier
  errors.employer = _validateIfDefined('checkEmpty', data.newData.employer); // Spouse/CommonLaw Employer
  errors.spousesBenefits = _validateIfDefined('checkEmpty', data.newData.spousesBenefits);
  errors.employer = _validateIfDefined('checkEmpty', data.newData.employer);
  errors.insuranceCarrier = _validateIfDefined('checkEmpty', data.newData.insuranceCarrier);
  errors.cert = _validateIfDefined('checkEmpty', data.newData.cert);
  errors.depCovReinstateStartDate = _validateIfDefined('date', data.newData.depCovReinstateStartDate, i18n.locale);
  errors.depCovReinstateEndDate = _validateIfDefined('date', data.newData.depCovReinstateEndDate, i18n.locale);

  // Sum all beneficiary shares to ensure it equals 100%
  if (data.newData?.shares) {
    const beneficiaryTotalShares = data.newData.type.toUpperCase() === 'CONTINGENT' ? _sumShares(data.newData.contingent) : _sumShares(data.newData.primary);
    const totalShares = beneficiaryTotalShares + Number(data.newData.shares);
    if (totalShares === 100) {
      errors.shares = null;
    } else {
      errors.shares = data.newData.type.toUpperCase() === 'CONTINGENT' ? i18n.t(tokens.labels.beneficiaries.pleaseEnsureAllContingentBeneficiaries) : i18n.t(tokens.labels.beneficiaries.pleaseEnsureAllPrimaryBeneficiaries);
    }
  }

  // Authorization Validation
  if (data.status === 'Pending Admin Review') {
    errors.AdminSignature = Services.validateInput('checkEmpty', data.signage.admin.signature);
    errors.AdminDatedOn = Services.validateInput('date', data.signage.admin.datedOn, i18n.locale);
  }
  if (data.status === 'Pending Member Review') {
    errors.memberSignature = Services.validateInput('checkEmpty', data.signage.member.signature);
    errors.memberDatedOn = Services.validateInput('date', data.signage.member.datedOn, i18n.locale);
  }

  // Check for any errors
  const hasErrors = Object.values(errors).some(Boolean);
  return hasErrors ? errors : false;
}
export default validateForm;